import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7d7ee7e0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header_container"
};
const _hoisted_2 = {
  class: "role"
};
const _hoisted_3 = {
  key: 0,
  class: "method"
};
import roleHooks from '@/hooks/roleHooks';
export default /*#__PURE__*/_defineComponent({
  __name: 'header',
  setup(__props) {
    const {
      setIsShowLeft,
      setIsShowRight,
      curSelectRoleInfo,
      showAvatar,
      isCurChatFinshed
    } = roleHooks();
    const setMode = status => {
      if (!isCurChatFinshed.value) {
        ElMessage.warning('请稍后切换');
        return;
      }
      showAvatar.value = status;
    };
    return (_ctx, _cache) => {
      var _ctx$$route$query, _unref2, _unref3, _unref4, _unref5;
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        style: _normalizeStyle({
          background: ((_ctx$$route$query = _ctx.$route.query) === null || _ctx$$route$query === void 0 ? void 0 : _ctx$$route$query.type) == 'show' ? 'none' : ''
        }),
        class: "menuWrapper cursor-p",
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => _unref(setIsShowLeft)(true), ["stop"]))
      }, null, 4), _createElementVNode("div", _hoisted_2, " 当前角色： " + _toDisplayString(((_unref2 = _unref(curSelectRoleInfo)) === null || _unref2 === void 0 ? void 0 : _unref2.name) && (((_unref3 = _unref(curSelectRoleInfo)) === null || _unref3 === void 0 ? void 0 : _unref3.name.length) > 10 ? ((_unref4 = _unref(curSelectRoleInfo)) === null || _unref4 === void 0 ? void 0 : _unref4.name.slice(0, 10)) + '...' : (_unref5 = _unref(curSelectRoleInfo)) === null || _unref5 === void 0 ? void 0 : _unref5.name)), 1), _ctx.$route.path == '/' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", {
        class: _normalizeClass(["item", {
          item_select: _unref(showAvatar)
        }]),
        onClick: _cache[1] || (_cache[1] = $event => setMode(true))
      }, [_createVNode(_component_el_tooltip, {
        class: "box-item",
        effect: "dark",
        content: "头像模式",
        placement: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          class: "icon",
          iconClass: "user"
        })]),
        _: 1
      })], 2), _createElementVNode("div", {
        class: _normalizeClass(["item", {
          item_select: !_unref(showAvatar)
        }]),
        onClick: _cache[2] || (_cache[2] = $event => setMode(false))
      }, [_createVNode(_component_el_tooltip, {
        class: "box-item",
        effect: "dark",
        content: "对话模式",
        placement: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          class: "icon",
          iconClass: "userRemove"
        })]),
        _: 1
      })], 2)])) : _createCommentVNode("", true), _ctx.$route.path == '/' ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "task_menu",
        onClick: _cache[3] || (_cache[3] = _withModifiers($event => _unref(setIsShowRight)(true), ["stop"]))
      }, [_createVNode(_component_svg_icon, {
        class: "icon",
        iconClass: "taskMenu"
      })])) : _createCommentVNode("", true)]);
    };
  }
});